import React, { useContext, useEffect, useState } from "react"
import { ApplicationContext } from "../context";
import { LabelConfigs } from '../configurations';
import { PopoverSelectView } from "@yodlee/common-components";
import { DataUtils } from "../utilities";
import { getAuthenticationDetails } from "../utilities/authentication";
import { Col, Icon, Row, Spin, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { SVG } from "../assets";
import { faSearchMinus } from "@fortawesome/pro-regular-svg-icons";

enum BrandType {
    YODLEE = 4
}

interface IProps {
    onUserChange(user: string, role?: string | number): void
}

const YSLUserSelector: React.FC<IProps> = ({ children, onUserChange }) => {

    const { onload } = useContext(ApplicationContext);

    const loggedInBrand = onload ? { id: onload.financialInstitution.id, name: onload.financialInstitution.name, type: onload.financialInstitution.type, brands: onload.financialInstitution.brands } : undefined;
    const isYodlee = loggedInBrand?.type.id === BrandType.YODLEE;
    const [filteredData, setFilteredData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [roles, setRoles] = useState<any>([]);
    const [selectedRole, setSelectedRole] = useState<any>();
    const [selectedUser, setSelectedUser] = useState<any>();
    const [users, setUsers] = useState<any>([]);
    
    useEffect(() => {
        if(filteredData && filteredData.length === 0)
        {
            DataUtils.insightsUsers(getAuthenticationDetails())
                .get()
                .then((data)=>{
                    setFilteredData(data.filter((roleUserData: any)=> {
                        return roleUserData.users.normal
                            .filter((item: any)=>item.status === 'Active')
                            .length>0
                    }));
                    setIsLoading(false);
            });
        }
      }, []);

      useEffect(() => {
        if(filteredData.length > 0){
            setRoles(filteredData.map((item: any)=>{
                return ({key:item.role.id, value:item.role.name})
            }));
            setSelectedRole({key: filteredData[0].role.id, value: filteredData[0].role.name});
            let roleUsers = filteredData[0].users.normal
                .filter((item: any)=>item.status === 'Active')?.map((item: any)=>{
                     return ({key:item.id, value:item.name})
             })
            setUsers(roleUsers);
            onUserChange(roleUsers[0].value, filteredData[0].role.id);
            setSelectedUser({key:roleUsers[0].key, value:roleUsers[0].value});
        }
      },[filteredData])

    return (
        <React.Fragment>
            {
                !isLoading ? filteredData && filteredData.length > 0 ?
                <React.Fragment>
                    <div className="background-blue-5 color-white padding-xs padding-lg-horizontal" style={{ height: "38px" }}>
                        <div style={{ float: "left" }}>
                        {
                        isYodlee && roles.length !== 0 && 
                        <React.Fragment>
                                {LabelConfigs.SELECT_ROLE} :
                                <span className="margin-left-xs" />
                                <PopoverSelectView
                                    maxWidth="unset"
                                    minWidth="300px"
                                    trigger="hover"
                                    onSelect={(item)=>{
                                        setSelectedRole({key: item.key, value: item.value})
                                        let filteredUsers = filteredData.find((data: any)=>{
                                            return data.role.id === item.key
                                        })
                                        let roleUsers = filteredUsers.users.normal
                                            .filter((item: any)=>item.status === 'Active')?.map((item: any)=>{
                                                return ({key:item.id, value:item.name})
                                        })
                                        setUsers(roleUsers);
                                        setSelectedUser({key:roleUsers[0].key, value:roleUsers[0].value});
                                        onUserChange(roleUsers[0].value, item.key);
                                    }}
                                    selectedData={selectedRole}
                                    data={roles}
                                >
                                    <span className="cursor-pointer color-white">
                                        <b>
                                        {selectedRole && selectedRole.value}
                                            <span className="margin-left-xs" />
                                            <Icon className="color-white fix-icon-top-1-px" component={() => <FontAwesomeIcon icon={faChevronDown} />} />
                                        </b>
                                    </span>
                                </PopoverSelectView>
                                <span className="margin-left-xs" /> 
                        </React.Fragment>
                        }  
                        <React.Fragment>
                            {LabelConfigs.VIEW_INSIGHTS_FOR} :
                            <span className="margin-left-xs" />
                            <PopoverSelectView
                                    maxWidth="unset"
                                    minWidth="300px"
                                    trigger="hover"
                                    onSelect={(item)=>{
                                    setSelectedUser({key: item.key, value: item.value})
                                    onUserChange(item.value, selectedRole.key);
                                    }}
                                    selectedData={selectedUser}
                                    data={users}
                                >
                                    <span className="cursor-pointer color-white">
                                        <b>
                                        {selectedUser && selectedUser.value}
                                            <span className="margin-left-xs" />
                                            <Icon className="color-white fix-icon-top-1-px" component={() => <FontAwesomeIcon icon={faChevronDown} />} />
                                        </b>
                                    </span>
                                </PopoverSelectView> 
                        </React.Fragment>
                        </div>
                    </div>
                    {children}
                </React.Fragment>:
                <React.Fragment>
                    <Row type="flex" style={{ height: "100%" }} align="middle" justify="center">
                        <Col span={16} className="align-center">
                            <Icon style={{ fontSize: "90px", borderRadius: '50%', backgroundColor: "#F2F8FC", padding: "61px" }} className="cursor-pointer color-blue-5" component={() => <FontAwesomeIcon icon={faSearchMinus} />} />
                            <br />
                            <br />
                            <Typography.Title level={2} className="color-gray-5">
                                We can’t find any data.
                            </Typography.Title>
                        </Col>
                    </Row>                 
                </React.Fragment>:
                    <React.Fragment>
                        <Row type="flex" style={{ height: "80vh" }} justify="center" align="middle">
                            <Col>
                                <Spin size="large" indicator={<Icon type="loading" />} />
                            </Col>
                        </Row>
                    </React.Fragment>
            }
        </React.Fragment>
    )
}

export default YSLUserSelector
